import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class InsightApiService {
  public INSIGHT_REQUEST = environment.apiUrl + '/v2/';
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };
  public httpPostOptionsFile = {
    withCredentials: true
};
  constructor(private http:HttpClient, private apiRequest: ApiRequestService) { }

  getInsightList(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/insight-list',data);
    // return this.http.post(this.INSIGHT_REQUEST + "insight-list", data, this.httpPostOptions);
  }

  addInsight(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/add-insight',data);
    // return this.http.post(this.INSIGHT_REQUEST + "add-insight", data, this.httpPostOptions);
  }

  addVocClip(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/repo/addVOC',data);
    // return this.http.post(this.INSIGHT_REQUEST + "repo/addVOC", data, this.httpPostOptions);
  }

  addVocIntroScreen(data): Observable<any>{
    let baseUrl: string = environment.apiVocIntro;
    let options = {"baseUrl":baseUrl}
    options['httpOptions'] = this.httpPostOptionsFile;
    // let options = {"baseUrl":"https://voc-dev.crownit.in"}
    // return this.apiRequest.request('POST','/voc/intro',data);
    return this.apiRequest.request('POST','/voc/intro',data,options);
  }

  updateVocClip(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/repo/editVOC',data);
    // return this.http.post(this.INSIGHT_REQUEST + "repo/editVOC", data, this.httpPostOptions);
  }
  // uploadMultipleFile(data): Observable<any>{
  //   return this.http.post(this.INSIGHT_REQUEST + "repo/uploadFiles", data, this.httpPostOptions);
  // }
  // inviteMultipleEmail(data): Observable<any>{
  //   return this.http.post(this.INSIGHT_REQUEST + "repo/uploadInviteEmail", data, this.httpPostOptions);
  // }
  deleteVocClip(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/repo/deleteVOC',data);
    // return this.http.post(this.INSIGHT_REQUEST + "repo/deleteVOC", data, this.httpPostOptions);
  }


  updateCommentVisibility(data){
    return this.apiRequest.request('POST','/v2/insight-edit',data);
    // return this.http.post(this.INSIGHT_REQUEST + "insight-edit", data, this.httpPostOptions);
  }
  copyVocURL(data){
    return this.apiRequest.request('POST','/v2/repo/copyVOC',data);
    // return this.http.post(this.INSIGHT_REQUEST + "repo/copyVOC", data, this.httpPostOptions);
  }
  openCopiedVOC(data){
    return this.apiRequest.request('POST','/v2/repo/openCopiedVOC',data);
    // return this.http.post(this.INSIGHT_REQUEST + "repo/openCopiedVOC", data, this.httpPostOptions);
  }
  addClubVoc(data) {
    return this.http.post(this.INSIGHT_REQUEST + "voc/club", data, this.httpPostOptions);
  }
  editClubVoc(data) {
    return this.http.put(this.INSIGHT_REQUEST + "voc/club", data, this.httpPostOptions);
  }
  deleteClubVoc(data) {
    return this.http.put(this.INSIGHT_REQUEST + "voc/club", data, this.httpPostOptions);
  }
  getVocClubs(uuid) {
    return this.http.get(this.INSIGHT_REQUEST + 'repo/club/'+uuid, this.httpPostOptions);
  }
}
